
import React from 'react';
import { Button } from '../../../components/base/Button';

export const ProcessSection: React.FC = () => {
  const steps = [
    {
      number: '1',
      title: 'Free Assessment',
      description: 'Receive a comprehensive loft assessment and detailed quote based on your property',
      image: 'https://readdy.ai/api/search-image?query=Professional%20insulation%20expert%20conducting%20free%20loft%20assessment%20with%20clipboard%20and%20measuring%20tools%2C%20examining%20attic%20space%2C%20providing%20detailed%20evaluation%2C%20customer%20consultation&width=400&height=300&seq=step1&orientation=landscape'
    },
    {
      number: '2',
      title: 'Professional Installation',
      description: 'Schedule expert installation with our certified team for optimal results',
      image: 'https://readdy.ai/api/search-image?query=Professional%20insulation%20installation%20team%20working%20in%20loft%20space%20with%20high-quality%20materials%2C%20expert%20installation%20process%2C%20safety%20equipment%2C%20professional%20workmanship&width=400&height=300&seq=step2&orientation=landscape'
    },
    {
      number: '3',
      title: 'Energy Efficient Home',
      description: 'Enjoy your newly insulated home with improved comfort and reduced energy bills',
      image: 'https://readdy.ai/api/search-image?query=Happy%20family%20in%20warm%20comfortable%20home%20with%20excellent%20insulation%2C%20cozy%20living%20space%2C%20energy%20efficient%20heating%2C%20comfortable%20indoor%20temperature%2C%20satisfied%20customers&width=400&height=300&seq=step3&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Easy Steps to Your Energy Efficient Home
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-6">
                <img 
                  src={step.image}
                  alt={step.title}
                  className="w-full h-64 object-cover object-top rounded-lg shadow-lg"
                />
                <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-12 h-12 bg-emerald-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                  {step.number}
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-700 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button href="/process" size="lg">
            Learn More About Our Process
          </Button>
        </div>
      </div>
    </section>
  );
};
